import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
  name: 'userslice',
  initialState: {
    value: {
      user: localStorage.getItem('activeUser') ? JSON.parse(localStorage.getItem('activeUser')!) : {},
    } as any,
  },
  reducers: {
    setActiveUser: (state, action: { type: string; payload: any }) => {
      state.value.user = action.payload;
    },
    setUserInitalState: (state) => {
      state.value = { user: {} };
    },
  },
});

export const { setActiveUser, setUserInitalState } = userSlice.actions;

export default userSlice.reducer;
